module.exports = __webpack_public_path__ + "img/no_image.4bc810c4.jpg";